import React, { useState, useEffect } from "react";
import SiteHeader from "./components/SiteHeader";
import About from "./components/About";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import SiteFooter from "./components/SiteFooter";


export default function App() {
  // dark mode feature provided by https://www.pullrequest.com/blog/create-a-persisting-dark-mode-with-react/
  // with additional debugging by https://www.reddit.com/r/learnreactjs/comments/o3gvu9/how_to_create_a_persisting_dark_mode_with_react/
  const [darkMode, setDarkMode] = useState(() => JSON.parse(localStorage.getItem("DARK_MODE")));
  const toggleDarkMode = () => setDarkMode(darkMode ? false : true);
  useEffect(() => {
    localStorage.setItem("DARK_MODE", darkMode);
  }, [darkMode]);


  return (
    <div className="container" data-theme={darkMode ? "dark" : "light"}>
      <main className="markdown-body">
        <div id="controls">
          <span id="dark-mode" onClick={toggleDarkMode}>
            {darkMode ?
              <svg xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd"><path d="M6 18h12c3.311 0 6-2.689 6-6s-2.689-6-6-6h-12.039c-3.293.021-5.961 2.701-5.961 6 0 3.311 2.688 6 6 6zm12-10c-2.208 0-4 1.792-4 4s1.792 4 4 4 4-1.792 4-4-1.792-4-4-4z" /></svg>
              :
              <svg xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd"><path d="M18 18h-12c-3.311 0-6-2.689-6-6s2.689-6 6-6h12.039c3.293.021 5.961 2.701 5.961 6 0 3.311-2.688 6-6 6zm-12-10c2.208 0 4 1.792 4 4s-1.792 4-4 4-4-1.792-4-4 1.792-4 4-4z" /></svg>}
          </span>
        </div>
        <SiteHeader />
        <About />
        <Projects />
        <Contact />
        <SiteFooter />
      </main>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/App.js